module.exports = __webpack_public_path__ + "static/media/Cerner_Logo.b1c0a6c1.png";